import { render, staticRenderFns } from "./PBCard.vue?vue&type=template&id=15cc6ae0&"
import script from "./PBCard.vue?vue&type=script&lang=js&"
export * from "./PBCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports